import React from 'react';
import {
  Award,
  Globe,
  Users,
  BookOpen
} from 'lucide-react';
import './ImprovementsSection.css';

function ImprovementsSection() {
  const [inView, setInView] = React.useState(false);

  React.useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
        }
      },
      { threshold: 0.2 }
    );

    const element = document.getElementById('improvements-section');
    if (element) observer.observe(element);

    return () => observer.disconnect();
  }, []);

  const strengths = [
    {
      icon: Award,
      title: "Certified IELTS and TOEFL Trainers",
      description: "Our trainers hold internationally recognized certifications"
    },
    {
      icon: BookOpen,
      title: "Advanced Business Communication",
      description: "Equipped with advanced credentials in Business Communication"
    },
    {
      icon: Globe,
      title: "Global Standards Training",
      description: "Experienced in training students for international standards"
    },
    {
      icon: Users,
      title: "Confidence Building Focus",
      description: "Focused on nurturing confidence alongside language skills"
    }
  ];


  return (
    <section id="improvements-section" className="improvements-section">
      <div className="parallax-bg"></div>
      <div className="content-container">
        <div className={`improvements-content ${inView ? 'animate' : ''}`}>
          <div className="header-section">
            <h1 className="improvements-heading">WHAT POWERS US?</h1>
            <div className="divider"></div>
            <h3 className="sub-heading">Our biggest strength lies in our EXPERT TRAINERS.</h3>
          </div>

          <div className="strengths-grid">
            {strengths.map((strength, index) => {
              const IconComponent = strength.icon;
              return (
                <div key={index} className={`strength-card fade-in-card`} style={{animationDelay: `${index * 0.2}s`}}>
                  <div className="strength-icon">
                    <IconComponent size={28} />
                  </div>
                  <div className="strength-content">
                    <h4>{strength.title}</h4>
                    <p>{strength.description}</p>
                  </div>
                </div>
              );
            })}
          </div>

        
        </div>
      </div>
    </section>
  );
}

export default ImprovementsSection;
